import { ClockCircleOutlined, CloseCircleFilled } from '@ant-design/icons';
import { type ComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/comunicazioneDTO.ts';
import { EnumComunicazioneDTOCodiceStatoRegistrazioneUscita } from '@framework/api-client/api/inquiries-compile/schemas/enumComunicazioneDTOCodiceStatoRegistrazioneUscita.ts';
import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { VerticalSpace } from '@framework/ui/components/space/VerticalSpace.tsx';
import { Space, Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

export interface ICommunicationSenderProtocolProps {
  communication?: ComunicazioneDTO | null;
  withTopSpacing?: boolean;
}

/**
 * Mostra i dettagli dello stato di protocollazione di una
 * comunicazione.
 */
export function CommunicationSenderProtocol(
  props: ICommunicationSenderProtocolProps,
) {
  const { communication, withTopSpacing } = props;

  const theme = useTheme();
  const { t } = useTranslation();

  if (!communication) return null;

  const state = communication?.codiceStatoRegistrazioneUscita;
  const number = communication?.numeroProtocolloUscita;
  const date = communication?.dataRegistrazioneUscita;

  const errorMessage = t(
    'communications-sender-protocol.tooltip-title.error-protocolling',
    'Errore nella protocollazione della comunicazione',
  );
  const processingMessage = t(
    'communications-sender-protocol.tooltip-title.processing-protocolling',
    'Protocollo in lavorazione',
  );

  return (
    <>
      {withTopSpacing && <VerticalSpace size={6} />}
      <Space size={8} wrap>
        {state ==
          EnumComunicazioneDTOCodiceStatoRegistrazioneUscita.FALLIMENTO && (
          <Tooltip title={errorMessage}>
            <Tag color="error">
              <CloseCircleFilled
                aria-label={errorMessage}
                style={{
                  color: theme.colorError,
                }}
              />{' '}
              {t('communications-sender-protocol.tag.errore', 'ERRORE')}
            </Tag>
          </Tooltip>
        )}
        {state ==
          EnumComunicazioneDTOCodiceStatoRegistrazioneUscita.IN_LAVORAZIONE && (
          <Tooltip title={processingMessage}>
            <Tag color="processing">
              <ClockCircleOutlined
                aria-label={processingMessage}
                style={{
                  color: theme.colorInfo,
                }}
              />{' '}
              {t(
                'communications-sender-protocol.tag.processing',
                'IN LAVORAZIONE',
              )}
            </Tag>
          </Tooltip>
        )}
        {date && (
          <div>
            {t(
              'communications-sender-protocol.protocol-date',
              'Data protocollo',
            )}
            :{' '}
            <b>
              <ISODate date={date} format="DD/MM/YYYY" />
            </b>
          </div>
        )}
        {number && (
          <div>
            {t('communications-sender-protocol.protocol-number', 'Protocollo')}:{' '}
            <b>{number}</b>
          </div>
        )}
      </Space>
    </>
  );
}
